import FontFaceObserver from "fontfaceobserver";

export default class ObserveFontFace {
  constructor() {
    const fontObserver = new FontFaceObserver(
      this.fontFamily,
      this.fontOptions,
    );
    fontObserver
      .load()
      .then(this.onLoad)
      .catch((error) => {
        console.error(error);
      });
  }

  get fontFamily() {
    return "Tiempos Text";
  }

  get fontOptions() {
    return {
      weight: 400,
      style: "normal",
    };
  }

  get testString() {
    return "Tiempos Text font family";
  }

  onLoad() {
    document.querySelector("body").classList.add(`tiempos-text-loaded`);
  }
}
